import React from "react";
import styles from "./companyProfile.module.css";
// import BackIcon from '../../assets/BackIcon.svg';
import compProfile from "../../../Assets/Company_Icon.png";
// import StudentCard from "../studentCard";
import { Link, useNavigate } from "react-router-dom";
import CompInfoCard from "../CompInfoCard";
import { useState } from "react";
import { Circle, Img } from "@chakra-ui/react";
import BackButton from "Components/Back/BackButton";
const CompanyProfile = ({ company }) => {
  const navigate = useNavigate();
  return (
    <div className={styles.container}>
      <div className={styles.back} onClick={() => navigate(-1)}>
        <BackButton />
      </div>
      {/* companyinfo  */}
      <div className={styles.companyInfo}>
        <div className={styles.nameDiv}>
          {/* logo */}
          <Circle className={styles.logo} size={65}>
            <Img src={company?.profilePhoto} alt="logo" objectFit={"contain"} />
          </Circle>

          <div className={styles.nameSec}>
            <p className={styles.name}>{company?.companyName}</p>
            <p className={styles.address}>
              {company?.companyAddress?.split("_")?.join(" ")}
            </p>
          </div>
        </div>
        <div className={styles.subContainer}>
          {/* col1 */}
          <div className={styles.col1}>
            <div className={styles.col11}>
              <div className={styles.grp}>
                <p className={styles.grpTitle}>Industry</p>
                <p className={styles.grpInfo}>Internet Publishing</p>
              </div>

              <div className={styles.grp}>
                <p className={styles.grpTitle}>Founded in</p>
                <p className={styles.grpInfo}>
                  {company?.companyEstablished?.slice(0, 4)}
                </p>
              </div>
            </div>
            <div className={styles.col12}>
              <div className={styles.grp}>
                <p className={styles.grpTitle}>Company Website</p>
                <p
                  className={styles.grpInfo}
                  style={{
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    window.open(company?.websiteLink, "_blank");
                  }}
                >
                  {company?.websiteLink}
                </p>
              </div>
            </div>
          </div>
          <div className={styles.col2}>
            <p className={styles.grpTitle}>About Company</p>
            <p className={styles.grpPara}>{company?.bio}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyProfile;
